import { FunctionComponent } from "react";

interface NotificationsPageIcon {
  fill?: string;
  width?: number;
  height?: number;
}

export const NotificationsPageIcon: FunctionComponent<
  NotificationsPageIcon
> = ({ fill = "currentColor", width = 14, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1C12.3807 1 13.5 2.11929 13.5 3.5C13.5 4.32033 13.1025 5.04513 12.4922 5.50098C12.4975 5.80746 12.5 6.14002 12.5 6.5V8.5C12.5 9.42848 12.5006 10.1751 12.4219 10.7607C12.3412 11.3608 12.1689 11.8663 11.7676 12.2676C11.3663 12.6689 10.8608 12.8412 10.2607 12.9219C9.67511 13.0006 8.92848 13 8 13H6C5.07152 13 4.32489 13.0006 3.73926 12.9219C3.13919 12.8412 2.6337 12.6689 2.23242 12.2676C1.83114 11.8663 1.6588 11.3608 1.57813 10.7607C1.49943 10.1751 1.5 9.42848 1.5 8.5V6.5C1.5 5.57152 1.49943 4.82489 1.57813 4.23926C1.6588 3.63919 1.83114 3.1337 2.23242 2.73242C2.6337 2.33114 3.13919 2.1588 3.73926 2.07812C4.32489 1.99943 5.07152 2 6 2H8C8.35958 2 8.69183 2.00183 8.99805 2.00684C9.4539 1.39664 10.1797 1 11 1ZM6 3C5.04308 3 4.37563 3.00066 3.87207 3.06836C3.38289 3.13413 3.12396 3.25494 2.93945 3.43945C2.75494 3.62396 2.63413 3.88289 2.56836 4.37207C2.50066 4.87563 2.5 5.54308 2.5 6.5V8.5C2.5 9.45692 2.50066 10.1244 2.56836 10.6279C2.63413 11.1171 2.75494 11.376 2.93945 11.5605C3.12396 11.7451 3.38289 11.8659 3.87207 11.9316C4.37563 11.9993 5.04308 12 6 12H8C8.95692 12 9.62437 11.9993 10.1279 11.9316C10.6171 11.8659 10.876 11.7451 11.0605 11.5605C11.2451 11.376 11.3659 11.1171 11.4316 10.6279C11.4993 10.1244 11.5 9.45692 11.5 8.5V6.5C11.5 6.30506 11.4963 6.12216 11.4951 5.9502C11.335 5.98237 11.1696 6 11 6C9.61929 6 8.5 4.88071 8.5 3.5C8.5 3.32984 8.51643 3.16354 8.54883 3.00293C8.37715 3.00195 8.19456 3 8 3H6ZM10 9C10.2761 9 10.5 9.22386 10.5 9.5C10.5 9.77614 10.2761 10 10 10H4C3.72386 10 3.5 9.77614 3.5 9.5C3.5 9.22386 3.72386 9 4 9H10ZM8.28613 7C8.56208 7.00023 8.78613 7.224 8.78613 7.5C8.78613 7.776 8.56208 7.99977 8.28613 8H4C3.72386 8 3.5 7.77614 3.5 7.5C3.5 7.22386 3.72386 7 4 7H8.28613ZM11 2C10.1716 2 9.5 2.67157 9.5 3.5C9.5 4.32843 10.1716 5 11 5C11.8284 5 12.5 4.32843 12.5 3.5C12.5 2.67157 11.8284 2 11 2Z"
        fill={fill}
      />
    </svg>
  );
};

export default NotificationsPageIcon;
